export default {
  methods: {
    toUppercase(val) {
      if (!val) return val;
      return val.toUpperCase();
    },
  },
};
